var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"business-hours-header"},[_c('h2',[_vm._v("Horário de funcionamento")])])
}]

export { render, staticRenderFns }